import { render, staticRenderFns } from "./otherIncome.vue?vue&type=template&id=063f7a52&scoped=true&"
import script from "./otherIncome.vue?vue&type=script&lang=js&"
export * from "./otherIncome.vue?vue&type=script&lang=js&"
import style0 from "./otherIncome.vue?vue&type=style&index=0&id=063f7a52&lang=scss&scoped=true&"
import style1 from "./otherIncome.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./otherIncome.vue?vue&type=style&index=2&id=063f7a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f7a52",
  null
  
)

export default component.exports